// getNodeKeyFromPath.js

/**
 * getNodeKeyFromPath
 *
 * Extracts the NodeWorkspace node key from a pathname, if present.
 *
 * @param {string} pathname - Router pathname.
 * @returns {string|null} Node key, or null when not on a node route.
 */
export default function getNodeKeyFromPath(pathname) {
  const match = String(pathname || '').match(/^\/node\/([^/?#]+)/);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}
